import styled from "styled-components";
import {brand, fontFamilies, fontWeights} from "theme/tokens";

/**
 * Shared v3 brand mark (design `.logo-mark`): the blue "T" tile with a soft ring shadow.
 *
 * Extracted from the NavBar so every surface renders the exact same mark (ticket #28; the top bar
 * uses it in both auth states since ui#96) — pair it with a "Transferify" wordmark sized for the
 * hosting chrome. Render it empty and `aria-hidden`: it draws the brand "T" itself.
 *
 * The "T" is generated content, not a DOM text node, because axe's `label-content-name-mismatch`
 * (WCAG 2.5.3, run by default since axe-core 4.14) reads a control's on-screen text nodes,
 * `aria-hidden` ones included, joined without a space: the nav's home button read as
 * "TTransferify", which its name "Transferify home" does not contain (kitecorp/transferify-ui#3842).
 * `aria-hidden` stays on every caller, since browsers do expose generated content to screen readers.
 */
export const LogoMark = styled.span`
	width: 30px;
	height: 30px;
	box-sizing: border-box;
	padding-top: 3px;
	border-radius: 8px;
	background: ${brand.logoBlue};
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${brand.white};
	font-weight: ${fontWeights.display};
	font-size: 22px;
	line-height: 1;
	font-family: ${fontFamilies.displaySerif};
	box-shadow: 0 2px 8px ${({theme}) => theme.tokens.ring};

	&::before {
		content: "T";
	}
`;
